import React from 'react';
import {
    BodyText,
    FlexContainer,
    Heading,
    LocationMarkIcon,
    Thumbnail,
} from '@placer-ui/components';

interface EditPoiDisplayProps {
    poi: {
        poiName: string;
        address: string;
    };
}

export const EditPoiDisplay = ({ poi }: EditPoiDisplayProps) => {
    return (
        <FlexContainer gap={8} alignItems="center">
            <Thumbnail src={<LocationMarkIcon color="blue" />} hasBackground size="medium" />
            <FlexContainer flexDirection="column">
                <Heading testId="poi-display-name" variant="h4">
                    {poi.poiName}
                </Heading>
                <BodyText testId="poi-display-address" size="small">
                    {poi.address}
                </BodyText>
            </FlexContainer>
        </FlexContainer>
    );
};
